goog.provide("shadow.js.shim.module$$mui$material$Switch$default");
shadow.js.shim.module$$mui$material$Switch$default = shadow.js.shim.module$$mui$material$Switch.default;
